import { cn } from "@/lib/utils";
import ChipSolid from "@/toggle-ui-kit/chip/chip-solid";
import { ChevronRight } from "lucide-react";

import type { Step } from "./steps";

export const StepCard = ({
  step,
  order,
  selected,
  disabled,
  onSelect,
}: {
  step: Step;
  order: number;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
}) => (
  <button
    type="button"
    aria-pressed={selected}
    disabled={disabled}
    aria-labelledby={`${step.id}-label`}
    aria-describedby={`${step.id}-description`}
    className={cn(
      "flex w-full items-center gap-4 overflow-clip rounded-xl border border-line-normal bg-white py-2 pr-4 pl-2 text-left disabled:cursor-not-allowed",
      selected && "border-blue-500 bg-blue-50",
    )}
    onClick={(e) => {
      e.stopPropagation();
      onSelect();
    }}
  >
    <div
      className={cn(
        "flex w-[150px] shrink-0 items-center justify-center self-stretch rounded-lg bg-background-gray-alternative p-3",
        selected && "bg-background-base",
      )}
    >
      <div className="relative flex w-full items-center justify-center gap-1">
        {step.thumb}
      </div>
    </div>
    <div className="flex min-w-0 flex-1 flex-col gap-0.5 py-2">
      <p className="caption-2-semibold font-bold text-blue-500">STEP{order}</p>
      <div className="flex items-center gap-1">
        <p
          id={`${step.id}-label`}
          className="body-1-normal-semibold whitespace-nowrap text-label-normal"
        >
          {step.label}
        </p>
        {step.xbrl && (
          <ChipSolid
            size="18px"
            rounded
            showRightIcon={false}
            className="bg-[#ffedd4] px-2 text-[#ff6900]"
          >
            XBRL
          </ChipSolid>
        )}
      </div>
      <p
        id={`${step.id}-description`}
        className="label-1-normal-regular text-label-alternative"
      >
        {step.description}
      </p>
    </div>
    <ChevronRight
      className="size-6 shrink-0 text-label-normal"
      strokeWidth={1.8}
    />
  </button>
);
